<!--路线信息-->
<template>
  <d2-container>
    <div style="background-color: #fff;padding: 0px 20px;">
      <div v-show="tableShow">
        <el-row style="margin-bottom: 20px">
          <el-col :span="4">
            <popover-form
              popoverWidth="900"
              :formConfig="advSearch"
              v-model="searchForm"
              @resetForm="resetForm('searchForm')"
              @onSubmit="searching"
            ></popover-form>
          </el-col>
          <el-col :span="20">
            <div class="text-align_right">
              <el-button
                type="success"
                v-if="!tableUse.show &&verifyAuthority('system.gsims.routeTable.import')"
                @click="dialogShow=true"
              >导入</el-button>
              <dialogUploadFile
                :importUrl="this.$url.importFiles.routeTable"
                exportFile="lu_xian"
                :dialogShow="dialogShow"
                @cancel="cancel"
              ></dialogUploadFile>
             <el-button
               type="primary"
               v-if="!tableUse.show &&verifyAuthority('system.gsims.routeTable.export')"
               @click="fileDownload($url.downLoad.exportroutesfile,{exportData,...searchForm})"
             >导出</el-button>
              <el-button
                type="primary"
                v-if="!tableUse.show && verifyAuthority('system.gsims.routeTable.add')"
                @click="addRow"
              >新增</el-button>
            </div>
          </el-col>
        </el-row>

        <div>
          <dynamic-table
            :tableSet="tableSet"
            :tableUse="tableUse"
            :tableData="tableData"
            :pageIndex="pageIndex"
            :pageShow="false"
            :pageShowX="true"
            @goPageIndex="goPageIndex"
            :pageCount="pageCount"
            @rowClick="rowClick($event)"
            @onButton="clickDialog($event)"
            @onSelection="selection($event)"
          ></dynamic-table>
        </div>
      </div>
      <div v-show="!tableShow">
        <div class="text-align_right">
          <el-button-group>
            <el-button type="primary" v-if="operationType!==3" @click="dataSubmit">保存</el-button>
            <el-button type="primary" v-if="operationType!==3" @click="resetForm('dataForm')">重置</el-button>
            <el-button type="primary" @click="close">返回</el-button>
          </el-button-group>
        </div>
        <divider title="路线信息" />
        <div>
          <dynamic-form
            ref="dataForm"
            :formConfig="formConfig"
            v-model="dataForm"
            :disabled="formDisabled"
          ></dynamic-form>
        </div>
        <div v-if="childShow">
          <divider title="断链信息"></divider>
          <div class="text-align_right" style="margin-bottom:10px;">
            <el-button
              type="primary"
              v-if="operationType!==3 && verifyAuthority('system.gsims.routeTable.childAdd')"
              @click="addChildRow"
            >新增</el-button>
          </div>
          <dynamic-table
            :tableSet="childTableSet"
            :operationShow="btnShow"
            :tableData="childTable"
            :pageShow="false"
            :pageIndex="childPageIndex"
            @goPageIndex="goChildPageIndex($event)"
            :pageCount="childPageCount"
            @rowClick="rowClickChild($event)"
          ></dynamic-table>
          <dialog-form
            :formConfig="childFormConfig"
            ref="childForm"
            :dialogFormVisible.sync="dialogFormVisible"
            v-model="childForm"
            :disabled="childDisabled"
            @onSubmit="childSubmit"
          ></dialog-form>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="!tableShow">
      <billing-info :billingInfo="dataForm"></billing-info>
    </template>
  </d2-container>
</template>
<script>
export default {
  name: "routeTable",
  props: {
    tableUse: {
      type: Object,
      default: () => {
        return {
          show: false,
          size: "small",
          type: "primary",
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          types: '0',
          isFull: "",
          title: "使用",
          name: "使用"
        };
      }
    },
    isRoadSection: {
      type: String,
      default: ()=>{
        return "0"
      }
    },
  },
  data() {
    return {
      dialogShow: false, //导入
      exportData: {},
      fileShow: false,
      tableShow: true,
      operationType: 1,
      formDisabled: false,
      advSearch: {
        list: [
          {
            type: "input",
            name: "路线编码",
            icon: "icon-input",
            options: {
              width: "100%",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "请输入",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1569217893785"
            },
            novalid: {},
            key: "1569217893785",
            model: "routeCode",
            rules: [
              {
                type: "string",
                message: "路线编码格式不正确"
              }
            ]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "请输入",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573006428064"
            },
            name: "路线名称",
            novalid: {},
            key: "1573006428064",
            model: "routeName",
            rules: [
              {
                type: "string",
                message: "路线名称格式不正确"
              }
            ]
          },
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择",
              required: false,
              showLabel: false,
              width: "",
              options: [
                {
                  value: "国道"
                },
                {
                  value: "省道"
                },
                {
                  value: "县道"
                },
                {
                  value: "乡道"
                },
                {
                  value: "村道"
                }
              ],
              remote: true,
              remoteType: "option",
              remoteOption: "option_1577526346145",
              filterable: false,
              remoteOptions: [],
              props: {
                value: "name",
                label: "name"
              },
              remoteFunc: this.getDict,
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "行政等级",
            key: "1577526346145",
            model: "administrativeLevelCode",
            rules: []
          },
          {
            type: "select",
            name: "公路等级",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "",
              required: false,
              showLabel: false,
              placeholder: "请选择",
              width: "100%",
              options: [
                {
                  value: "下拉框1"
                },
                {
                  value: "下拉框2"
                },
                {
                  value: "下拉框3"
                }
              ],
              remoteSearch: false,
              remoteSearchFunc: "",
              remoteFunc: this.getDict,
              remote: true,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "name",
                label: "name"
              },
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            novalid: {},
            key: "1569217931085",
            model: "highwayLevelCode",
            rules: []
          },
          {
            type: "select",
            name: "是否启用",
            icon: "icon-select",
            options: {
              defaultValue: "1",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择",
              required: false,
              showLabel: false,
              width: "",
              options: [
                {
                  label: "是",
                  value: "1"
                },
                {
                  label: "否",
                  value: "0"
                }
              ],
              remote: false,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "value",
                label: "label"
              },
              remoteFunc: "func_1569217957558",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            novalid: {},
            key: "1569217957558",
            model: "isValid",
            rules: []
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      advSearchShow: false,
      searchForm: {
        routeName: "",
        routeCode: "",
        highwayLevelCode: "",
        administrativeLevelCode: "",
        isValid: "",
        type: this.tableUse.types
      },

      tableSet: {
        tableColumn: [
          {
            prop: "routeName",
            label: "路线名称"
          },
          {
            prop: "routeCode",
            label: "路线编码"
          },
          {
            prop: "highwayLevelCode",
            label: "公路等级"
          },
          {
            prop: "startStake",
            label: "起点桩号(km)",
            type: "stake"
          },
          {
            prop: "endStake",
            label: "止点桩号(km)",
            type: "stake"
          },
          {
            prop: "isFull",
            label: "是否完整",
            type: "tag",
            options: [
              {
                value: "1",
                color: "success",
                label: "是"
              },
              {
                value: "0",
                color: "info",
                label: "否"
              },
              {
                value: null,
                color: "info",
                label: "否"
              }
            ]
          }
        ],
        tableColBtn: [
          {
            show: true,
            size: "small ",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-view",
            title: "查看",
            name: "查看",
            click: this.rowClick
          },
          {
            show: this.verifyAuthority("system.gsims.routeTable.edit"),
            size: "small ",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.edit
          },
          {
            show: this.verifyAuthority("system.gsims.routeTable.del"),
            // show: true,
            size: "small ",
            type: "danger",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-delete",
            title: "删除",
            name: "删除",
            click: this.del
          }
        ]
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      data: {},
      visible: false,
      childShow: false,
      childTable: [],
      deleteList: [],
      /***表单 */
      dataForm: {
        routeId: 0,
        routeName: "", // 路线名称
        routeCode: "", // 路线编码
        startStake: "", // 起点桩号
        startPosition: "", // 起点位置
        endStake: "", // 止点桩号
        endPosition: "", // 终点位置
        startLongitude: "", // 起点经度
        startLatitude: "", // 起点纬度
        endLongitude: "", // 止点经度
        endLatitude: "", // 止点纬度
        isChainbreak: "", // 是否断链
        highwayLevelCode: "", // 公路等级
        highwayLevelCodes: "", //公路等级s
        administrativeLevelCode: "", // 行政等级
        surfaceTypeCode: "", // 路面类型
        routeLen: 0, // 主线里程
        interflowLen: 0, // 互通长度
        interflowInt: 0, // 互通数量
        culvertInt: 0, // 涵洞（道）
        mainlineBridgeLen: "", // 主线桥梁总长(m)
        mainlineBridgeInt: "", // 主线桥梁数量(座)
        interflowOverpassLen: "", // 互通立交桥总长(m)
        interflowOverpassInt: "", // 互通立交桥数量(座)
        separateOverpassLen: 0, // 分离立交桥总长(m)
        separateOverpassInt: 0, // 分离立交桥数量(座)
        routeRemark: "", // 路线简介
        createUser: "", // 创建人
        createTime: "", // 创建时间
        updateUser: "", // 最后修改人
        updateTime: "", // 最后修改时间
        maintainUnitIds: "", // 管养单位
        delUser: "", // 删除人
        delTime: "", // 删除时间
        lastVersionId: "", // 上一版本路线主键(未体现)
        isValid: 0, // 是否启用(未体现)
        stakeVersionDate: "", // 桩号更新日期(未体现)
        stakeVersion: 0, // 桩号更新版本(未体现)
        isFinishStructure: "", // 是完成路面结构配置(未体现)
        chainbreakInt: 0, // 断链数量(未体现)
        isAcross: 0, // 是否交叉(未体现)
        acrossInt: 0, // 交叉数量(未体现)
        isFull: "",
        routeChains: "" //断链子表
      },
      formConfig: {
        list: [
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: true,
              dataType: "string",
              pattern: "",
              placeholder: "请输入路线名称",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573006428064"
            },
            name: "路线名称",
            novalid: {},
            key: "1573006428064",
            model: "routeName",
            rules: [
              {
                type: "string",
                message: "路线名称格式不正确"
              },
              {
                required: true,
                message: "路线名称必须填写"
              }
            ]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: true,
              dataType: "string",
              pattern: "/^[G|S|X|Y|Z|C][0-9]+$/",
              placeholder: "请输入路线编码",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573006486029"
            },
            name: "路线编码",
            novalid: {},
            key: "1573006486029",
            model: "routeCode",
            rules: [
              {
                type: "string",
                message: "路线编码格式不正确"
              },
              {
                required: true,
                message: "路线编码必须填写"
              },
              {
                pattern: /^[G|S|X|Y|Z|C][0-9]+$/,
                message: "路线编码为[G/S/X/Y/Z/C]开头+数字"
              }
            ]
          },
          {
            type: "stake",
            icon: "icon-number",
            options: {
              width: "120px",
              required: true,
              defaultValue: 0,
              min: 0,
              max: 99999,
              step: 1,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573006524695"
            },
            name: "起点桩号(km)",
            novalid: {},
            key: "1573006524695",
            model: "startStake",
            rules: [
              {
                required: true,
                message: "起点桩号必须填写"
              }
            ]
          },
          {
            type: "stake",
            icon: "icon-number",
            options: {
              width: "120px",
              required: true,
              defaultValue: 0,
              min: 0,
              max: 99999,
              step: 1,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573006581194"
            },
            name: "止点桩号(km)",
            novalid: {},
            key: "1573006581194",
            model: "endStake",
            rules: [
              {
                required: true,
                message: "止点桩号必须填写"
              }
            ]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "请输入起点位置",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573006623226"
            },
            name: "起点位置",
            novalid: {},
            key: "1573006623226",
            model: "startPosition",
            rules: [
              {
                type: "string",
                message: "起点位置格式不正确"
              }
            ]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "请输入终点位置",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573006661496"
            },
            name: "终点位置",
            novalid: {},
            key: "1573006661496",
            model: "endPosition",
            rules: [
              {
                type: "string",
                message: "终点位置格式不正确"
              }
            ]
          },
          {
            type: "longandlat",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: "",
              dataType: "number",
              min: 0,
              max: 180,
              step: 1,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573006720648"
            },
            name: "起点经度",
            novalid: {},
            key: "1573006720648",
            model: "startLongitude",
            rules: [
              {
                type: "string",
                message: "起点经度格式不正确"
              }
            ]
          },
          {
            type: "longandlat",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              dataType: "number",
              min: 0,
              max: 90,
              step: 1,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573006767335"
            },
            name: "起点纬度",
            novalid: {},
            key: "1573006767335",
            model: "startLatitude",
            rules: []
          },
          {
            type: "longandlat",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              dataType: "number",
              min: 0,
              max: 100,
              step: 1,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573006795360"
            },
            name: "止点经度",
            novalid: {},
            key: "1573006795360",
            model: "endLongitude",
            rules: []
          },
          {
            type: "longandlat",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              dataType: "number",
              min: 0,
              max: 90,
              step: 1,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573006817928"
            },
            name: "止点纬度",
            novalid: {},
            key: "1573006817928",
            model: "endLatitude",
            rules: []
          },
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择是否断链",
              required: true,
              showLabel: false,
              width: "250px",
              options: [
                {
                  label: "是",
                  value: "1"
                },
                {
                  label: "否",
                  value: "0"
                }
              ],
              remote: false,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "value",
                label: "label"
              },
              remoteFunc: "func_1573006851349",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "是否断链",
            novalid: {},
            key: "1573006851349",
            model: "isChainbreak",
            rules: [
              {
                required: true,
                message: "是否断链必须填写"
              }
            ]
          },
          {
            type: "select",
            name: "公路等级",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: true,
              disabled: true,
              clearable: false,
              placeholder: "自动生成",
              required: false,
              showLabel: false,
              width: "250px",
              options: [
                {
                  value: "name",
                  label: "name"
                }
              ],
              remote: true,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "name",
                label: "name"
              },
              remoteFunc: this.getDict,
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            novalid: {},
            key: "1572436605740",
            model: "highwayLevelCodes",
            rules: [
              {
                required: false,
                message: "公路等级必须填写"
              }
            ]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "自动生成",
              customClass: "",
              disabled: true,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573007055392"
            },
            name: "行政等级",
            novalid: {},
            key: "1573007055392",
            model: "administrativeLevelCode",
            rules: [
              {
                type: "string",
                message: "行政等级格式不正确"
              }
            ]
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 9999999,
              step: 1,
              precision: 0,
              disabled: true,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007316079"
            },
            name: "涵洞(道)",
            novalid: {},
            key: "1573008216276",
            model: "culvertInt",
            rules: []
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: false,
              dataType: "string",
              pattern: "",
              placeholder: "自动生成",
              customClass: "",
              disabled: true,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1573007185533"
            },
            name: "主线里程(km)",
            novalid: {},
            key: "1573008205917",
            model: "routeLen",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 999999999,
              step: 1,
              precision: 2,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007225635"
            },
            name: "互通长度(km)",
            novalid: {},
            key: "1573008199797",
            model: "interflowLen",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 999999,
              step: 1,
              precision: 0,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007271899"
            },
            name: "互通数量",
            novalid: {},
            key: "1573008196662",
            model: "interflowInt",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 999999999,
              step: 1,
              precision: 2,
              disabled: true,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007374464"
            },
            name: "主线桥梁总长(m)",
            novalid: {},
            key: "1573007374464",
            model: "mainlineBridgeLen",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 999999,
              step: 1,
              precision: 0,
              disabled: true,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007444028"
            },
            name: "主线桥梁数量(座)",
            novalid: {},
            key: "1573007444028",
            model: "mainlineBridgeInt",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 999999999,
              step: 1,
              precision: 2,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007501522"
            },
            name: "互通立交桥总长(m)",
            novalid: {},
            key: "1573007501522",
            model: "interflowOverpassLen",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 99999,
              step: 1,
              precision: 0,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007565772"
            },
            name: "互通立交桥数量(座)",
            novalid: {},
            key: "1573007565772",
            model: "interflowOverpassInt",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 999999999,
              step: 1,
              precision: 2,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007600526"
            },
            name: "分离立交桥总长(m)",
            novalid: {},
            key: "1573007600526",
            model: "separateOverpassLen",
            rules: []
          },
          {
            type: "number",
            icon: "icon-number",
            options: {
              width: "250px",
              required: false,
              defaultValue: 0,
              min: 0,
              max: 99999,
              step: 1,
              precision: 0,
              disabled: false,
              controlsPosition: "",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007623721"
            },
            name: "分离立交桥数量(座)",
            novalid: {},
            key: "1573007623721",
            model: "separateOverpassInt",
            rules: []
          },
          {
            type: "select",
            name: "是否启用",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择是否启用",
              required: true,
              showLabel: false,
              width: "",
              options: [
                {
                  label: "是",
                  value: "1"
                },
                {
                  label: "否",
                  value: "0"
                }
              ],
              remote: false,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "value",
                label: "label"
              },
              remoteFunc: "func_1569217957558",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            novalid: {},
            key: "1569217957558",
            model: "isValid",
            rules: [
              {
                required: true,
                message: "是否启用必须填写"
              }
            ]
          },
          {
            type: "textarea",
            icon: "icon-diy-com-textarea",
            options: {
              width: "500px",
              defaultValue: "",
              required: false,
              disabled: false,
              pattern: "",
              placeholder: "请输入路线简介",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              remoteFunc: "func_1573007681636"
            },
            name: "路线简介",
            novalid: {},
            key: "1573007681636",
            model: "routeRemark",
            rules: []
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "left",
          size: "medium",
          customClass: ""
        }
      },
      /***子表 */
      btnShow: true,
      childOperationType: 1,
      childPageIndex: 1,
      childPageCount: 0,
      childDisabled: false,
      dialogFormVisible: false,
      childFormConfig: {
        list: [
          {
            type: "select",
            icon: "icon-select",
            options: {
              defaultValue: "",
              multiple: false,
              disabled: false,
              clearable: false,
              placeholder: "请选择断链信息",
              required: true,
              showLabel: false,
              width: "",
              options: [
                {
                  value: "1",
                  label: "长链"
                },
                {
                  label: "短链",
                  value: "0"
                }
              ],
              remote: false,
              filterable: false,
              remoteOptions: [],
              props: {
                value: "value",
                label: "label"
              },
              remoteFunc: "func_1571837434080",
              customClass: "",
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true
            },
            name: "断链类型",
            novalid: {},
            key: "1571837434080",
            model: "chainType",
            rules: [
              {
                required: true,
                message: "断链类型必须填写"
              }
            ]
          },
          {
            type: "number",
            icon: "icon-input",
            options: {
              width: "250px",
              defaultValue: "",
              required: true,
              dataType: "string",
              pattern: "",
              min: 0.001,
              max: 999999999,
              precision: 3,
              step: 0.001,
              placeholder: "请输入断链长度",
              customClass: "",
              disabled: false,
              labelWidth: 100,
              isLabelWidth: false,
              hidden: false,
              dataBind: true,
              showPassword: false,
              remoteFunc: "func_1571837481759"
            },
            name: "断链长度(km)",
            novalid: {},
            key: "1571837481759",
            model: "length",
            rules: [
              {
                type: "number",
                message: "断链长度格式不正确"
              },
              {
                required: true,
                message: "断链长度必须填写"
              }
            ]
          }
        ],
        config: {
          labelWidth: 140,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      childTableSet: {
        tableColumn: [
          {
            prop: "chainType",
            label: "断链类型",
            type: "tag",
            options: [
              {
                value: "0",
                color: "danger",
                label: "短链"
              },
              {
                value: "1",
                color: "success",
                label: "长链"
              }
            ]
          },
          {
            prop: "length",
            label: "断链长度(km)",
            type: "chainLength"
          }
        ],
        tableColBtn: [
          {
            show: this.verifyAuthority("system.gsims.routeTable.childEdit"),
            size: "small ",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.childEdit
          },
          {
            show: this.verifyAuthority("system.gsims.routeTable.childDel"),
            size: "small ",
            type: "danger",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-delete",
            title: "删除",
            name: "删除",
            click: this.childDel
          }
        ]
      },
      childForm: {
        routeStructureBId: "", // 主键
        routeId: 0, // 路线编码
        chainId: "", //断链ID
        routeName: "",
        chainType: "", //断链类型
        length: 0,
        //startStake: "", //起点桩号
        //endStake: "", //止点桩号
        createUser: "", //创建人
        createTime: "", //创建时间
        updateUser: "", //最后修改人
        updateTime: "", //最后修改时间
        delUser: "", //删除人
        delTime: "", //删除时间
        isValid: "", //是否启用(未体现)
        isDelete: 0 //是否删除(未体现)
      },
      childEditIndex: 0
    };
  },
  created() {
    this.searchTable();
  },
  methods: {
    cancel() {
      this.dialogShow = false;
    },
    //勾选
    selection(val) {
      let data = new Array();
      if (val) {
        for (let item of val) {
          data.push(item.routeId);
        }
      }
      this.exportData = { rowCodes: data.toString() };
    },
    // 表格搜索
    searching(){
      this.pageIndex = 1;
      this.searchTable();
    },
    searchTable() {
      // this.pageIndex = 1;
      this.advSearchShow = false;
      this.searchForm.type=this.tableUse.show?this.tableUse.types:"1";
      if(this.isRoadSection==="2"){
        this.isRoadSection==="2" && (this.searchForm.isDefault=2)
        let obj = {
          ...this.searchForm,
          isFull: this.tableUse.isFull,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        this.$http.postHandle("", this.$url.route.search, obj).then(res => {
          this.tableData = res.data;
          this.pageCount = res.pageCount;
        });
      }else{
        this.isRoadSection==="1" && (this.searchForm.isDefault=0)
        let obj = {
          ...this.searchForm,
          isFull: this.tableUse.isFull,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        this.$http.postHandle("", this.$url.route.search, obj).then(res => {
          this.tableData = res.data;
          this.pageCount = res.pageCount;
        });
      }
    },
    // 跳转页数
    goPageIndex(pageIndex, pageSize) {
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.advSearchShow = false;
      this.searchForm.type=this.tableUse.show?this.tableUse.types:"1";
      if(this.isRoadSection==="2"){
        this.isRoadSection==="1" && (this.searchForm.isDefault=0)
        let obj = {
          ...this.searchForm,
          isFull: this.tableUse.isFull,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        this.$http.postHandle("", this.$url.route.search, obj).then(res => {
          this.tableData = res.data;
          this.pageCount = res.pageCount;
        });
      }else{
        this.isRoadSection==="1" && (this.searchForm.isDefault=0)
        let obj = {
          ...this.searchForm,
          isFull: this.tableUse.isFull,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        this.$http.postHandle("", this.$url.route.search, obj).then(res => {
          this.tableData = res.data;
          this.pageCount = res.pageCount;
        });
      }
    },
    // 新增
    addRow() {
      this.tableShow = false;
      this.formDisabled = false;
      this.operationType = 1;
      this.childTable = [];
      this.deleteList = [];
      this.btnShow = true;
      this.dataForm.highwayLevelCodes = [];
      this.resetForm("dataForm");
      
    },
    // 查看
    rowClick(row) {
      this.operationType = 3;
      this.tableShow = false;
      this.formDisabled = true;
      this.btnShow = false;
      this.$http
        .post(this.$url.route.getroutebycode, { routeId: row.routeId })
        .then(res => {
          let { data } = res;
          this.dataForm = data;
          this.dataForm.routeLen = this.dataForm.routeLen / 1000.0;
          if (res.data.highwayLevelCode) {
            this.dataForm.highwayLevelCodes =
              res.data.highwayLevelCode.indexOf(",") >= 0
                ? res.data.highwayLevelCode.split(",")
                : [res.data.highwayLevelCode];
          }
          this.childTable = this.$listSetList(data.routeChains);
          this.childPageCount = data.routeChains ? data.routeChains.length : 0;
        });
    },
    // 编辑
    edit(row, index) {
      this.operationType = 2;
      this.tableShow = false;
      this.formDisabled = false;
      this.btnShow = true;
      this.$http
        .post(this.$url.route.getroutebycode, { routeId: row.routeId })
        .then(res => {
          let { data } = res;
          this.dataForm = data;
          this.dataForm.routeLen = this.dataForm.routeLen / 1000.0;
          this.dataForm.highwayLevelCodes =
            res.data.highwayLevelCode.indexOf(",") >= 0
              ? res.data.highwayLevelCode.split(",")
              : [res.data.highwayLevelCode];
          this.childTable = this.$listSetList(data.routeChains);
          this.childPageCount = data.routeChains ? data.routeChains.length : 0;
          this.deleteList = [];
        });
    },
    // 删除
    del(row, index) {
      this.$msgDel(this.$url.route.deleteroute, {
        operationType: 8,
        routeId: row.routeId
      }).then(res => {
        if((this.tableData.length<=1)&&(this.pageIndex>1)){
          this.pageIndex=this.pageIndex-1;
        }
        this.searchTable();
      });
    },

    //获取字典
    getDict(target, targets) {
      let name = target.form.name;
      this.$http
        .post(this.$url.getDict, {
          search: name
        })
        .then(res => {
          let { data } = res;
          target.setList(data);
        });
    },
    //表单提交
    dataSubmit(key, value) {
      let url = "";
      let forms = this.$formSetForm(this.dataForm, this.dataForm);
      delete forms.highwayLevelCodes;
      if (this.operationType === 1) {
        url = this.$url.route.createroute;
      } else if (this.operationType === 2) {
        url = this.$url.route.updateroute;
      }
      this.$refs.dataForm.submit().then(res => {
        if (forms.isChainbreak == "1") {
          if (this.childTable && this.childTable.length >= 1) {
            forms.routeChains = this.$listSetList(
              this.childTable,
              this.deleteList
            );
            this.$http
              .postHandle("保存", url, {
                route: forms
              })
              .then(res => {
                this.tableShow = true;
                let { data } = res;
                this.resetForm("dataForm");
              });
          } else {
            this.$message.warning("断链信息不能为空");
          }
        } else {
          forms.routeChains = [];
          this.$http
            .postHandle("保存", url, {
              route: forms
            })
            .then(res => {
              this.tableShow = true;
              let { data } = res;
              this.resetForm("dataForm");
            });
        }
        this.searchTable();
      });
    },
    //关闭
    close() {
      this.$closePage(this.operationType).then(() => {
        this.tableShow = true;
        this.searchTable();
      });
    },

    //子表分页
    goChildPageIndex(val) {
      this.$http
        .post(this.$url.route.getchain, {
          routeId: this.dataForm.routeId,
          pageIndex: val,
          pageSize: 5
        })
        .then(res => {
          this.childTable = res.data;
          this.childPageCount = res.pageCount;
        });
    },
    //子表新增
    addChildRow() {
      this.dialogFormVisible = true;
      this.childOperationType = 1;
      this.childDisabled = false;
      this.resetForm("childForm");
    },
    //子表查看
    rowClickChild(row) {
      this.dialogFormVisible = true;
      this.childOperationType = 3;
      let childForm = this.$formSetForm(this.childForm, row);
      childForm.length = childForm.length / 1000;
      this.childForm = childForm;
      this.childDisabled = true;
    },
    //子表编辑
    childEdit(row, index) {
      this.dialogFormVisible = true;
      let childForm = this.$formSetForm(this.childForm, row);
      childForm.length = childForm.length / 1000;
      this.childForm = childForm;
      this.childDisabled = false;
      this.childOperationType = 2;
      this.childEditIndex = index;
    },
    //再次获取主表数据
    getDataForm() {
      this.$http
        .post(this.$url.route.getroutebycode, {
          routeId: this.dataForm.routeId
        })
        .then(res => {
          let { data } = res;

          this.dataForm.routeLen = this.dataForm.routeLen / 1000.0;
          this.childTable = data.routeChains;
          this.childPageCount = this.childTable.length;
        });
    },
    //子表提交
    childSubmit() {
      let childForm = this.$formSetForm(this.childForm, this.childForm);
      childForm.routeId = this.dataForm.routeId;
      childForm.length = childForm.length * 1000;

      if (this.childOperationType == 1) {
        this.childTable.push(childForm);
      } else {
        this.childTable.splice(this.childEditIndex, 1, childForm);
      }
      this.childPageCount = this.childTable.length;
      this.dialogFormVisible = false;
    },
    //子表删除
    childDel(row, index) {
      this.$localDel().then(res => {
        if (row.rowCode == 0) {
          this.childTable.splice(index, 1);
        } else {
          let forms = this.$formSetForm(this.childForm, row);
          forms.isDelete = 1;
          this.childTable.splice(index, 1);
          this.deleteList.push(forms);
        }
      });
    },
    //重置
    resetForm(formName) {
      let that = this;
      this.$nextTick(() => {
        that.$refs[formName].resetForm();
        this.dataForm.isValid = "1"
      });
    }
  },
  watch: {
    "dataForm.isChainbreak": function(val, old) {
      if (val == "1") {
        this.childShow = true;
      } else {
        this.childShow = false;
      }
    },
    "dataForm.routeCode": function(val, old) {
      let routeCode = val;
      var reg = new RegExp(/^[G|S|X|Y|Z|C][0-9]+$/);
      var g = new RegExp(/^[G][0-9]+$/);
      var s = new RegExp(/^[S][0-9]+$/);
      var x = new RegExp(/^[X][0-9]+$/);
      var y = new RegExp(/^[Y][0-9]+$/);
      var z = new RegExp(/^[Z][0-9]+$/);
      var c = new RegExp(/^[C][0-9]+$/);
      if (reg.test(routeCode)) {
        if (g.test(routeCode)) {
          this.dataForm.administrativeLevelCode = "国道";
        } else if (s.test(routeCode)) {
          this.dataForm.administrativeLevelCode = "省道";
        } else if (x.test(routeCode)) {
          this.dataForm.administrativeLevelCode = "县道";
        } else if (y.test(routeCode)) {
          this.dataForm.administrativeLevelCode = "乡道";
        } else if (z.test(routeCode)) {
          this.dataForm.administrativeLevelCode = "专用道";
        } else if (c.test(routeCode)) {
          this.dataForm.administrativeLevelCode = "村道";
        }
      }
    }
  }
};
</script>


<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/basic/roadProduction/routeTable.vue"
}
</vue-filename-injector>
